module.exports = __webpack_public_path__ + "img/light-mud-decal-07.86bc2d38.png";